import { useDesignTokens, renderInlineCssVars } from '@sas/nova-commons/theme';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import './Pane.css';
import cn from './Pane.css.json';
export const Pane = forwardRef((props, ref) => {
    const dt = useDesignTokens();
    const paneTokens = renderInlineCssVars(getPaneTokens(dt), 'pane');
    return (React.createElement("div", Object.assign({}, props, { className: cx(cn.pane, props.className), ref: ref, style: Object.assign(Object.assign({}, paneTokens), props.style) }), props.children));
});
function getPaneTokens(dt) {
    return {
        bg: dt.reportTokens.backgrounds.panes.bg,
    };
}
